"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStoreLocatorClosest = void 0;

var _useGeoLocation2 = require("./use-geo-location");

var _helpers = require("../helpers");

var _useStoreLocatorData2 = require("./use-store-locator-data");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStoreLocatorClosest = function useStoreLocatorClosest(isInEditor) {
  var _useGeoLocation = (0, _useGeoLocation2.useGeoLocation)(isInEditor),
      currentLocation = _useGeoLocation.currentLocation,
      locationAllowed = _useGeoLocation.locationAllowed;

  var _useStoreLocatorData = (0, _useStoreLocatorData2.useStoreLocatorData)(isInEditor),
      storeLocationsData = _useStoreLocatorData.storeLocationsData;

  var locationFound = currentLocation.longitude && currentLocation.latitude;

  var getClosestLocation = function getClosestLocation(currentLocation, locationData) {
    var closestLocation = null;
    locationData.map(function (target) {
      var targetLocation = target.location;

      if (targetLocation) {
        var distance = (0, _helpers.getDistance)({
          currentLocation: currentLocation,
          targetLocation: {
            lat: targetLocation.latitude,
            lng: targetLocation.longitude
          }
        });
        closestLocation = !closestLocation || distance < closestLocation.distance ? _objectSpread(_objectSpread({}, target), {}, {
          distance: distance.toFixed(2)
        }) : closestLocation;
      }
    });
    return closestLocation;
  };

  var closestLocation = storeLocationsData ? getClosestLocation(currentLocation, storeLocationsData.storeLocationList) : null;
  return {
    locationAllowed: locationAllowed,
    closestLocation: closestLocation,
    locationFound: locationFound,
    disableButton: !locationFound || !locationAllowed || isInEditor
  };
};

exports.useStoreLocatorClosest = useStoreLocatorClosest;